import { mdiBookOpenPageVariantOutline } from "@mdi/js"
import type { ViewConfig } from "@kontextwerk/control-web-frame"
import type { PageNavigationEntry } from "@kontextwerk/web-sdk/core/navigation/types"
import type { GuideLessonSummary } from "../../../../api/kehrblatt/learning-guide"

export const workspaceConfig = {
  viewId: "organization",
  subview: { id: "learning", parentPageId: "learning", parentTabTitle: "KehrBlatt lernen" },
} satisfies NonNullable<ViewConfig["workspace"]>

export const learningBasePath = (organization: string) =>
  `/organizations/${encodeURIComponent(organization)}/learn`

export const learningLessonPath = (
  basePath: string,
  lesson: Pick<GuideLessonSummary, "topic_key" | "key">,
) => `${basePath}/${encodeURIComponent(lesson.topic_key)}/${encodeURIComponent(lesson.key)}`

export const learningNavigationItem = (organization: string) => ({
  id: "learning",
  title: "KehrBlatt lernen",
  href: learningBasePath(organization),
  icon: mdiBookOpenPageVariantOutline,
})

/** The learning owner renders its chapter navigation inside one stable page. */
export function buildLearningPages(
  basePath: string,
  content: NonNullable<PageNavigationEntry["content"]>,
): PageNavigationEntry[] {
  return [
    { id: "learning", title: "KehrBlatt lernen", path: basePath, contentKey: "guide", content },
  ]
}
